 /* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { useSnackbar } from 'react-simple-snackbar'
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Avatar, Button, Paper, Grid, Container } from '@material-ui/core';
import Uploader from './Uploader';
import { getProfilesByUser, updateProfile, getProfile, createProfile } from '../../../actions/profile';
import useStyles from './styles';
import Input from './Input';
import ProfileDetail from './Profile';




const Form = () => {

  const user = JSON.parse(localStorage.getItem('profile'))
  
  const initialState = { 
  name: '', 
  email: '',
  phoneNumber: '',
  businessName: '',
  contactAddress: '', 
  logo: '',
  paymentDetails: ''
};

  const [form, setForm] = useState(initialState);
  const location = useLocation()
  const dispatch = useDispatch();
  const classes = useStyles();
  const { profiles}  = useSelector((state) => state.profiles)
  // const { profile}  = useSelector((state) => state.profile)
  //(profiles)
 const [switchEdit, setSwitchEdit] = useState(0)

 
  // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar()


  useEffect(() => {
    if(switchEdit === 1) {
      setForm(profiles)
    }
  },[switchEdit])

  useEffect(() => {
    // dispatch(getProfilesByUser({ search: user?.result?.id }))
    dispatch(getProfile(  user?.userProfile?.id ))
  },[location, switchEdit])


    
      // //(profiles)
  
  const handleSubmit = async(e) => {
    e.preventDefault();
    localStorage.setItem('profileDetail', JSON.stringify({...profiles}))

    if (profiles?.id) {
      // Existing profile (Prisma id already known) — update it in place.
      dispatch(updateProfile(profiles.id, form, openSnackbar));
    } else {
      // No profile row exists yet for this user (e.g. first-time logo/setup)
      // -- profiles?.id is undefined, so calling updateProfile here would
      // POST /profiles/undefined. Create the profile instead.
      const created = await dispatch(createProfile({ ...form, userId: [user?.result?.id] }));
      if (created) {
        // Keep localStorage's cached user in sync so a future getProfile()
        // call (which reads user?.userProfile?.id) can find this profile.
        localStorage.setItem('profile', JSON.stringify({ ...user, userProfile: created }));
        openSnackbar("Profile created successfully");
        // Same auto-refresh updateProfile already does on success, so the
        // newly created profile/logo shows immediately instead of only
        // after a manual page reload.
        window.location.reload();
      } else {
        openSnackbar("Unable to create profile");
      }
    }

    setSwitchEdit(0)
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <div>

      {switchEdit === 0 && (
        <Container component="main" maxWidth="sm">
        <Paper className={classes.paper} elevation={0} >
        <ProfileDetail  profiles={profiles} />
        <Button variant="outlined" style={{margin: '30px', padding: '15px 30px'}} onClick={() => setSwitchEdit(1)}>Edit Profile</Button>
       </Paper>
       </Container>
      )}

    {switchEdit === 1 && (
      <Container component="main" maxWidth="sm">
      <Paper className={classes.paper} elevation={1} >
      <div style={{display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        borderBottom: 'solid 1px #dddddd',
        paddingBottom: '20px'
        }}>
        {/* Uploader writes the newly uploaded Cloudinary URL into form.logo,
            not profiles.logo (the previously saved value) — prefer it so a
            freshly uploaded logo shows immediately instead of the old one. */}
        <Avatar style={{width: '100px', height: '100px'}} src={form?.logo || profiles?.logo} alt="" className={classes.avatar} />
      </div>
        <form className={classes.form} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Uploader form={form} setForm={setForm} />
            <Input name="email" label="Email Address" handleChange={handleChange} type="email" half value={form?.email} />
            <Input name="phoneNumber" label="Phone Number" handleChange={handleChange} type="text" half value={form?.phoneNumber}/>
            <Input name="businessName" label="Business Name" handleChange={handleChange} type="text" value={form?.businessName}/>
            <Input name="contactAddress" label="Bank Details" handleChange={handleChange} type="text" value={form?.contactAddress} />
            <Input name="paymentDetails" label="Payment Details/Notes" handleChange={handleChange} type="text" multiline rows="4" value={form?.paymentDetails} />
          </Grid>
          <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
           Update Settings
          </Button>
          <Grid container justifyContent="flex-end">
          </Grid>
        </form>
      </Paper>
    </Container>
    )}
    </div>
  );
};

export default Form;
